// src/components/features/content/form-steps/RawSelect.jsx
import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  FormHelperText,
  Box,
  alpha,
  useTheme
} from '@mui/material';

/**
 * RawSelect - A direct Material-UI Select component for use in situations
 * where MagicSelect causes issues
 */
const RawSelect = ({
  name,
  label,
  value,
  onChange,
  options = [],
  error,
  helperText,
  required = false,
  disabled = false,
  icon = null,
  ...props
}) => {
  const theme = useTheme();

  // Handle value changes
  const handleChange = (e) => {
    const selectedValue = e.target.value;
    console.log(`Raw ${name} select changed to:`, selectedValue);
    
    // Call the onChange handler with the name and value
    if (onChange) {
      if (name === 'brandId' || name === 'clientId') {
        // For brand/client fields, use param order (name, value)
        onChange(name, selectedValue);
      } else {
        // For other fields, use standard event handling
        onChange(selectedValue);
      }
    }
  };
  
  return (
    <FormControl
      fullWidth
      error={Boolean(error)}
      required={required}
      disabled={disabled}
      variant="outlined"
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: 1,
          transition: theme.transitions.create(
            ['border-color', 'box-shadow', 'background-color'],
            { duration: theme.transitions.duration.short }
          ),
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: error 
            ? theme.palette.error.main 
            : alpha(theme.palette.primary.main, 0.2),
        },
        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: error 
            ? theme.palette.error.main 
            : theme.palette.primary.main,
          borderWidth: 2,
        },
      }}
    >
      <InputLabel id={`${name}-label`} required={required}>
        {label}
      </InputLabel>
      <Select
        labelId={`${name}-label`}
        id={name}
        name={name}
        value={value || ''}
        onChange={handleChange}
        label={label}
        startAdornment={icon ? (
          <Box component="span" sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
            {icon}
          </Box>
        ) : null}
        {...props}
      >
        {options.map((option, index) => (
          <MenuItem 
            key={option.value || `option-${index}`} 
            value={option.value || ''}
          >
            {option.label || option.value || ''}
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default RawSelect;